import React from 'react';
import { FiShoppingCart } from 'react-icons/fi';

import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { t } from 'i18next';

interface AddToCartButtonProps {
  product: any;
  selectedImage: string;
  setShowAlert: (value: boolean) => void;
}

const AddToCartButton: React.FC<AddToCartButtonProps> = ({
  product,
  selectedImage,
  setShowAlert,
}) => {
  const { addToCart } = useCart();
  const navigate = useNavigate();

  const handleAddToCart = () => {
    const accessToken = Cookies.get('access_token');
    if (accessToken) {
      addToCart({
        id: product.id,
        image: selectedImage || product.image,
        name: product.name,
        user: product.nickname,
        price: product.price,
        originalPrice: product.originalPrice,
        category: product.category,
        quantity: 1,
        description: product.description,
        usageInstructions: product.usageInstructions,
        tags: product.tags || [],
        star: product.star || 0,
        review: product.review || 0,
        profileImageUrl: product.profileImageUrl,
      });
      setShowAlert(true);
    } else {
      toast.error('로그인이 필요합니다.');
      navigate('/login');
    }
  };

  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
        handleAddToCart();
      }}
      className="bg-white hover:bg-gray-100 w-full h-[50px] border border-gray-200 transition duration-300 ease-in-out rounded-full shadow-lg flex items-center justify-center  cursor-pointer"
    >
      {/* <FiShoppingCart
        className="cursor-pointer font-bold text-lg text-[#272d37c5] hover:text-[#272d3784]"
        onClick={(e) => {
          e.stopPropagation();
          handleAddToCart();
        }}
      /> */}
      <div className="Pretendard-Bold text-base text-[#000] tracking-wide">
        {t('product_card.add_to_cart')}
      </div>
    </div>
  );
};

export default AddToCartButton;
